import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/random-team-stacking/actions';
import Const from 'constants';
import InputCheckbox from 'components/atoms/inputs/input-checkbox';

class ChooseTeamsRandomly extends Component {
    onChange(isChecked) {
        this.props.dispatch(Action.set('TeamsAreChosenRandomly', isChecked));
    }

    render() {
        const {stacking} = this.props;

        const isChecked = stacking.isTeamsChosenRandomly();

        return <InputCheckbox label="Randomly select teams" value="1" checked={isChecked} onChange={::this.onChange} />;
    }
}

function mapStatesToProps(state) {
    const {randomTeamStacking} = state;
    return {
        stacking: randomTeamStacking,
    };
}

export default connect(mapStatesToProps)(ChooseTeamsRandomly);
